import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router';

// Utils
import PageUrlsUtils from 'Shared/utils/PageUrls.utils';

// Hooks
import { useToggle, useQueryParam } from 'Shared/utils/hooks';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

// Components
import { WpPageLayout, WpPageBody } from 'Wpds/components/page-layout';
import KudoItemModal from 'Shared/components/KudoItem/KudoItemModal';
import UserProfileBody from './UserProfileBody';

// Styles
import './UserProfilePage.scss';

const UserProfilePage = () => {
  const history = useHistory();
  const { userSlug } = useParams();

  const [show] = useQueryParam('show');
  const [uuid] = useQueryParam('uuid');

  const { user: currentUser } = useCurrentUser();
  const currentUserSlug = currentUser.slug;

  // show current user profile if no slug is specified
  const slugToFetch = userSlug || currentUserSlug;

  const [isKudoModalOpen, toggleIsKudoModalOpen] = useToggle(false);

  useEffect(() => {
    if (show === 'kudo' && uuid) {
      toggleIsKudoModalOpen();
    }
  }, [show, uuid]);

  const handleCloseKudoModal = () => {
    toggleIsKudoModalOpen();
    history.push(PageUrlsUtils.makeUserProfilePageUrl(slugToFetch));
  };

  const baseClassName = 'UserProfilePage';

  return (
    <>
      <WpPageLayout className={baseClassName} width="container">
        <WpPageBody>
          <UserProfileBody />
        </WpPageBody>
      </WpPageLayout>
      {isKudoModalOpen && (
        <KudoItemModal isOpen={isKudoModalOpen} toggleIsOpen={handleCloseKudoModal} feedbackUuid={uuid as string} />
      )}
    </>
  );
};

export default UserProfilePage;
